export default __webpack_public_path__ + "static/media/020_start.last.7deee6e3.webp";